import { bindActionCreators } from 'redux';
import { Clickable, FocusTrap, Image, MemberMenu, NavBar } from '@ahmdigital/ui';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
// @ts-expect-error - Automatic, Please fix when editing this file
import liveChatActions from '@ahmdigital/livechat/lib/actions';

import combineMenuItemsWithCmsData from './utils/combine-menu-items-with-cms-data';
import config from '../../config';
import constants from '../../ahm-constants';
import getMenuItems from './menu-items';
import LoginMenu from './components/login-menu';
import selectIsAbcSupportedAndAvailable from '../../selectors/select-is-abc-supported';
import styles from './styles.module.sass';
import useIsAfterHydration from '../../hooks/use-is-after-hydration';
import useNavigationPerks from './hooks/use-navigation-perks';

type HeaderProps = {
  centerBlock?: ReactNode;
  isMinimalMenu: boolean;
};

const emptyPerksData: ReturnType<typeof useNavigationPerks>['items'] = [];

const imageProps = {
  alt: 'Go to ahm home',
  className: styles.logoImage,
  height: 69,
  priority: true,
  src: `${config.get('static:url')}/files/images/logos/ahm-logo-black.svg`,
  useNextImage: true,
  width: 164,
};

const Header = ({ centerBlock, isMinimalMenu }: HeaderProps) => {
  const [isActive, setIsActive] = useState(false);
  const isAfterHydration = useIsAfterHydration();
  const isAbcSupportedAndAvailable: boolean = useSelector(selectIsAbcSupportedAndAvailable);
  const liveChatStatus: number = useSelector((state: RootStateOrAny) => state.livechat.status);
  const pathname: string | undefined = useSelector((state: RootStateOrAny) => state.router.location?.pathname);
  const dispatch = useDispatch();
  const actionsLiveChat = useMemo(() => bindActionCreators(liveChatActions, dispatch), [dispatch]);

  const perksData = useNavigationPerks({ skip: !isAfterHydration });
  const data = isAfterHydration ? perksData?.items ?? emptyPerksData : emptyPerksData;

  const menuItems = useMemo(
    () => getMenuItems(actionsLiveChat, isAbcSupportedAndAvailable, liveChatStatus, { pathname }),
    [actionsLiveChat, isAbcSupportedAndAvailable, liveChatStatus, pathname],
  );
  const combinedMenuItems = useMemo(() => combineMenuItemsWithCmsData(menuItems, data), [data, menuItems]);
  const handleStateChange = useCallback(({ isOpen }: { isOpen: boolean }) => setIsActive(isOpen), []);

  return (
    <FocusTrap isActive={isActive}>
      <MemberMenu menu={<LoginMenu />} centerBlock={centerBlock} />
      <NavBar
        onStateChange={handleStateChange}
        menuItems={combinedMenuItems}
        independentSubMenus
        isAccordionMenu
        isMinimal={isMinimalMenu}
        logo={
          <Clickable to={constants.URLS.SALES.HOME} title="Go to ahm home">
            <Image {...imageProps} />
          </Clickable>
        }
      />
    </FocusTrap>
  );
};

export default Header;
